export default {
  boxBorderRadius: '4px',
  headerBorderRadius: '10px',
  boxShadow: '0px 2px 4px rgba(184, 200, 224, 0.4)'
};
